import { useI18n } from 'vue-i18n';

export function useLocalizedDateHelpers() {
  const { locale } = useI18n();

  function formatDate(value: number | string | Date, formatOptions?: Intl.DateTimeFormatOptions) {
    return new Date(value).toLocaleDateString(locale.value, formatOptions);
  }

  function formatDateTime(
    value: number | string | Date,
    formatOptions?: Intl.DateTimeFormatOptions,
  ) {
    return new Date(value).toLocaleString(locale.value, formatOptions);
  }

  function formatTime(value: number | string | Date, formatOptions?: Intl.DateTimeFormatOptions) {
    return new Date(value).toLocaleTimeString(locale.value, formatOptions);
  }

  return {
    formatDate,
    formatDateTime,
    formatTime,
  };
}
